import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const Divider = styled<any, any>('hr', 'divider', 'filterItemDropdown')`
    ${propStyles};
`;

Divider.defaultProps = {
    borderWidth: '1px',
    borderColor: 'gray500',
    borderStyle: 'dotted none none none',
};

export default Divider;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/Divider.tsx